module.exports = __webpack_public_path__ + "static/media/MongoDB_Badge.ce316b43.png";